import { createEntityAdapter } from '@ngrx/entity';
import { userPermissionListActions } from '../actions';
import { sortApplicationsByNameWithHomeFirst } from './application';
export const NON_PRODUCTION_APPS = ['Sandbox'];
export const userPermissionListAdapter = createEntityAdapter({
    selectId: (item) => item.uuid,
    sortComparer: false
});
export const INIT_STATE = userPermissionListAdapter.getInitialState({
    loaded: false,
    loading: false
});
export function reducer(state = INIT_STATE, action) {
    switch (action.type) {
        case userPermissionListActions.LOAD_BY_ID: {
            return {
                ...state,
                loading: true
            };
        }
        case userPermissionListActions.USER_ROLE_UPDATE_LOAD_BY_ID_SUCCESS:
        case userPermissionListActions.LOAD_BY_ID_SUCCESS: {
            const sortedPayload = {
                ...action.payload,
                applications: action.payload.applications.slice().sort(sortApplicationsByNameWithHomeFirst)
            };
            return {
                ...userPermissionListAdapter.upsertOne(sortedPayload, state),
                loaded: true,
                loading: false
            };
        }
        case userPermissionListActions.LOAD_BY_ID_FAILED: {
            return {
                ...state,
                loaded: false,
                loading: false
            };
        }
        default: {
            return state;
        }
    }
}
export const getUserPermissionListLoading = (state) => state.loading;
export const getUserPermissionListLoaded = (state) => state.loaded;
//# sourceMappingURL=user-permission-list.js.map